<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">Member category</label>
          <div class="col-sm-4" style="padding-top: 7px">
            {{ $route.query.membershipCategoryId }}
          </div>
          <label class="col-sm-2 control-label"> Member Name </label>
          <div class="col-sm-4" style="padding-top: 7px">
            {{ $route.query.membershipName }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">{{ total }}{{ $t("message.datagridresult") }}</div>
              <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @sort-change="sortChange">
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                <el-table-column prop="titleen_US" label="Event Name" min-width="120"></el-table-column>
                <el-table-column prop="eventTypesName" label="Event Types" min-width="90"></el-table-column>
                <el-table-column label="M+ Privilege " min-width="70">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.mPrivilege"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="HKPM Privilege" min-width="80">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.hkpmPrivilege"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="Exclusive Hightlight (Member event for guest) " min-width="120">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.exclusiveHightlight"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="Upcoming event " width="130">
                  <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.upcomingEvent"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column label="Action" width="100" fixed="right">
                  <template slot-scope="scope">
                    <el-popconfirm title="Are you sure to delete the selected content?" confirmButtonText="Yes" cancelButtonText="No" @confirm="deleteList(scope.row)">
                      <el-button size="mini" slot="reference" icon="el-icon-delete"> </el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :current-page="page + 1"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col> -->
            </div>
            <div class="col-sm-12 row" style="margin-top: -30px">
              <div class="pull-right">
                <button class="btn btn-white" @click="addEvent">Add Event</button>
                <button class="btn btn-white" @click="saveEvent">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      searchName: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "asc",
      sortField: "id",
      selectEventTypeDlg: false,
      eventTypes: "",
      status: "",
      categoryList: [],
      statusObj: [],
      membershipCategoryId: "",
    };
  },
  created: function () {},
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.sortField = this.sortField;
      objdata.sortType = this.sortType;
      objdata.startRow = 0;
      objdata.maxRows = 1000000;
      objdata.membershipId = this.$route.query.id;
      objdata.membershipCategoryId = this.membershipCategoryId;
      objdata.apiUrl = "/getMembershipEventList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      for (var i = 0; i < data.data.resultList.length; i++) {
        for (var j = 0; j < data.data.resultList[i].eventLangMap.length; j++) {
          if (data.data.resultList[i].eventLangMap[j].langCode == "en_US") {
            data.data.resultList[i]["title" + "en_US"] = data.data.resultList[i].eventLangMap[j].title;
          }
          //   if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
          //     data.data.resultList[i]['title'+'zh_HK'] = data.data.resultList[i].langMap[j].title;
          //   }
          //   if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
          //     data.data.resultList[i]['title'+'zh_CN'] = data.data.resultList[i].langMap[j].title;
          //   }
        }
      }
      this.rows = data.data.resultList;
      this.setObj();
      this.total = data.data.totalRows;
    },

    async search() {
      this.page = 0;
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleSizeChange: function (val) {
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange: function (val) {
      this.page = val - 1;
      this.init();
    },
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    sortChange: function (val) {
      if (val.order == "ascending") {
        this.sortType = "ASC";
        this.sortField = val.prop;
      } else if (val.order == "descending") {
        this.sortType = "DESC";
        this.sortField = val.prop;
      } else {
        this.sortType = "ASC";
        this.sortField = "id";
      }
      this.init();
    },
    setObj: function () {
      let list = null;
      for (list of this.rows) {
        if (list.eventTypes === 1) {
          list.eventTypesName = "Performing Arts";
        } else if (list.eventTypes == 2) {
          list.eventTypesName = "Exhibitions";
        } else if (list.eventTypes == 3) {
          list.eventTypesName = "Talks / Forums";
        } else if (list.eventTypes == 4) {
          list.eventTypesName = "Guided Tour";
        } else if (list.eventTypes == 5) {
          list.eventTypesName = "Workshops";
        } else if (list.eventTypes == 6) {
          list.eventTypesName = "Screening";
        } else if (list.eventTypes == 7) {
          list.eventTypesName = "Festival";
        } else if (list.eventTypes == 9) {
          list.eventTypesName = "Other";
        }
        if (list.status === false) {
          list.statusName = this.$i18n.t("message.Inactive");
        } else if (list.status == true) {
          list.statusName = this.$i18n.t("message.Active");
        }
      }
    },
    addRaw(item) {
      setTimeout(() => {
        this.rows.push({
          eventId: item.eventId,
          mPrivilege: item.mPrivilege,
          hkpmPrivilege: item.hkpmPrivilege,
          exclusiveHightlight: item.exclusiveHightlight,
          upcomingEvent: item.upcomingEvent,
          titleen_US: item.titleen_US,
          eventTypesName: item.eventTypesName,
        });
        // this.$set(this, "rows", this.rows);
      });
      //   this.rows.push(item);
      //   this.$set(this, "rows", this.rows);
    },
    addEvent() {
      var that = this;
      this.$store.commit("seteventlist", {
        callback: function (list) {
          that.$store.commit("seteventlist", { string: "", boolean: false });
          list.forEach(item => {
            var isExist = false;
            that.rows.forEach(row => {
              if (row.eventId == item.id) {
                isExist = true;
              }
            });
            if (!isExist) {
              item.eventId = item.id;
              item.mPrivilege = false;
              item.hkpmPrivilege = false;
              item.exclusiveHightlight = false;
              item.upcomingEvent = false;
              that.addRaw(item);
            }
          });
        },
        boolean: true,
        button: [],
      });
    },
    async saveEvent() {
      var membershipEvents = [];
      this.rows.forEach(item => {
        membershipEvents.push({
          eventId: item.eventId,
          mPrivilege: item.mPrivilege,
          hkpmPrivilege: item.hkpmPrivilege,
          exclusiveHightlight: item.exclusiveHightlight,
          upcomingEvent: item.upcomingEvent,
        });
      });
      let objdata = this.getAuthObj();
      objdata.membershipId = this.$route.query.id;
      objdata.membershipEvents = JSON.stringify(membershipEvents);
      objdata.apiUrl = "/saveMembershipEvent";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.state.edit = false;
        this.$toastr.s("Success");
        this.init();
      }
    },
    deleteList(row) {
      this.rows = this.rows.filter(item => item.eventId !== row.eventId);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
